import $ from 'jquery'

'use strict';

// 固定フッター表示
$(window).scroll(function() {
  let scr = $(this).scrollTop();
  if (scr > 200) {
    $("#content_bottom_fixed").fadeIn('slow');
  }
  if (scr > 150) {
    $(".submit_block_bottom").fadeIn('slow');
  }
});
var breakPoint = 737;
// トップページグループ吹き出しの表示位置設定
if ($(window).width() > breakPoint ) {
  $('li.group .group_inner').hover(function() {
    let groupListHeight, groupPositionBottom, groupPositionLeft
    if ($(this).hasClass('setting_2018')) {
      groupListHeight = $(this).height();
      groupPositionBottom = -groupListHeight + 5;
      groupPositionLeft = $(this).parent().position().left + 10;
      $(this).find('.group_js_wrap').css('left', -groupPositionLeft).css('bottom', -groupPositionBottom).stop(true, true).fadeIn(300);
    } else {
      groupListHeight = $(this).height();
      groupPositionBottom = 0;
      groupPositionLeft = 0;
      if ($(this).hasClass('noImg')) {
        groupPositionBottom = -groupListHeight +7;
        groupPositionLeft = $(this).parent().position().left +10;
      } else {
        groupPositionBottom = -groupListHeight - 14;
        groupPositionLeft = $(this).parent().position().left - 150;
      }
      $(this).find('.group_js_wrap').css('left', -groupPositionLeft).css('bottom', -groupPositionBottom).stop(true, true).fadeIn(300);
    }
  },
  function() {
    $(this).find('.group_js_wrap').stop(true, true).fadeOut(300);
  });
} else {
  $('.box_wap li.group .accordion_btn').on('click', function() {
    $(this).parents('.group').toggleClass('open').find('.group_js_wrap').slideToggle();
  });
}

// 別ウィンドウをサイズ指定で開く
$('a.js_popup_link').on('click', function() {
  window.open($(this).attr('href'), 'popup_window', 'height=900,width=800,scrollbars=yes,maximize=yes,resizable=yes');
  return false;
});

//アピールポイント並び替え
function shuffleContent(container) {
  const content = container.find("> *")
  const total = content.length
  content.each(function() {
    content.eq(Math.floor(Math.random()*total)).prependTo(container)
  });
}
$(function() {
  shuffleContent($("ul#appeal"))
});

//twitter
!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+'://platform.twitter.com/widgets.js';fjs.parentNode.insertBefore(js,fjs);}}(document, 'script', 'twitter-wjs');
